/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {refreshPaychecksHome} from '../api'

export const useMutationRefreshPaychecksHome = createReactQueryMutationHook('refreshPaychecksHome', refreshPaychecksHome)
